// Define the type for the customization options
export interface AgencyConfiguration {
  // Basic styling using React's CSSProperties
  styling?: React.CSSProperties;
  // Component customization
  top?: React.ComponentType<any>;
  left?: React.ComponentType<any>;
  widgetTitleOverrideKey?: string;
  headerTitleOverrideKey?: string;
  startingMessageOverrideKey?: string;
  closedWidgetCloseButtonClassName?: string;
  closedWidgetCloseIconClassName?: string;
  preventRefreshOnUrlChange?: boolean;
  enableEmailCollection?: boolean;
  // Other configuration
  options?: {
    widgetPosition?: 'right' | 'left' | 'center';
    animationDuration?: number;
  };
}

// Sample top component for a specific agency
export const SampleTopComponent: React.FC<{
  onOpenChat?: () => void;
}> = ({ onOpenChat }) => (
  <div style={{ fontFamily: 'serif' }}>
    <button
      onClick={() => onOpenChat?.()}
      className="block w-full mb-2 px-4 py-2.5 bg-gray-500 text-white rounded-full hover:bg-gray-400 transition-colors text-sm font-medium shadow-sm"
    >
      Sell House
    </button>
    <button
      onClick={() => onOpenChat?.()}
      className="block w-full px-4 py-2.5 bg-gray-500 text-white rounded-full hover:bg-gray-400 transition-colors text-sm font-medium shadow-sm"
    >
      Get Valuation
    </button>
  </div>
);

// Sample left component for a specific agency
export const SampleLeftComponent: React.FC = () => (
  <div className="absolute -left-16 top-1/2 -translate-y-1/2 flex items-center">
    <svg 
      width="48" 
      height="48" 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className="text-gray-500"
    >
      <path 
        d="M9 5L16 12L9 19" 
        stroke="currentColor" 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  </div>
);

// Map of agency-specific customizations
export const agencyCustomizations: Record<string, AgencyConfiguration> = {
  'test': {
    styling: {
      backgroundColor: '#8cc6d9',
      borderRadius: '50px',
      color: '#335566',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
      fontFamily: 'serif'
    },
    top: SampleTopComponent,
    left: SampleLeftComponent,
    options: {
      animationDuration: 300
    }
  },
  'agency020': {
    widgetTitleOverrideKey: 'widgetTitle_agency020',
    headerTitleOverrideKey: 'headerTitle_agency020',
  },
  'agency021': {
    closedWidgetCloseButtonClassName: 'w-6 h-6',
    closedWidgetCloseIconClassName: 'h-4 w-4',
    preventRefreshOnUrlChange: true,
  },
  'agency026': {
    startingMessageOverrideKey: 'startingMessage_agency026'
  },
  'agency023': {
    enableEmailCollection: true,
  }
};

// Helper function to get customization by agency ID
export function getAgencyConfig(agencyId?: string): AgencyConfiguration {
  if (!agencyId) return {};
  return agencyCustomizations[agencyId];
} 